//export default class Hero {
//   constructor() {
//     this.$sections = document.querySelectorAll('section.hero');
//   }
//}
//
//new Hero();

import simpleParallax from "simple-parallax-js";

document.addEventListener("DOMContentLoaded", () => {
  var image = document.querySelectorAll(".parallax-image");
  new simpleParallax(image, {
    orientation: "up",
    overflow: true,
    delay: 0.6,
  });

  document.querySelectorAll(".hero-image-zoom").forEach((element) => {
    element.classList.add("zoom-hero");
  });
});
